import { CALENDLY_REGEX, INSTAGRAM_REGEX, LINK_REGEX, TIKTOK_REGEX, TWITTER_REGEX, YOUTUBE_REGEX } from './Constants/REGEX';

export const validateUsername = () => {
  return {
    minLength: {
      value: '3',
      message: 'Username must be at least 3 characters.',
    },
    maxLength: {
      value: '15',
      message: 'Username must be shorter than 15 characters.',
    },
    pattern: {
      value: /^[a-zA-Z0-9_]+$/i,
      message: "Username can only contain letters, numbers and '_'",
    },
  };
};

export const validatePassword = () => {
  return {
    minLength: {
      value: '8',
      message: 'Password must be at least 8 characters.',
    },
    maxLength: {
      value: '20',
      message: 'Password must be shorter than 20 characters.',
    },
    pattern: {
      value: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$/,
      message: 'Password must be at least one letter, one number and one special character.',
    },
  };
};

export const validateLink = (linkType = 'LINK') => {
  if (linkType === 'INSTAGRAM') {
    return {
      pattern: {
        value: INSTAGRAM_REGEX,
        message: 'Please enter valid instagram URL',
      },
    };
  }
  if (linkType === 'TIKTOK') {
    return {
      pattern: {
        value: TIKTOK_REGEX,
        message: 'Please enter valid tiktok URL',
      },
    };
  }
  if (linkType === 'TWITTER') {
    return {
      pattern: {
        value: TWITTER_REGEX,
        message: 'Please enter valid twitter URL',
      },
    };
  }
  if (linkType === 'CALENDLY') {
    return {
      pattern: {
        value: CALENDLY_REGEX,
        message: 'Please enter valid calendly URL',
      },
    };
  }
  if (linkType === 'YOUTUBE') {
    return {
      // pattern: {
      //   value: YOUTUBE_REGEX,
      //   message: 'Please enter valid youtube URL',
      // },
      validate: (value, formValues) => {
        console.log('value', value)
        console.log('REGEZ', YOUTUBE_REGEX.test(value))
        // if (YOUTUBE_REGEX.test(value)) {
        if (YOUTUBE_REGEX.test(value)) {
          return true;
        } else {
          return 'Please enter valid youtube URL';
        }
      },
      // pattern: {
      //   value: /^(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com)\/(?:watch\?v=)?(.+)/,
      //   message: 'Please enter valid youtube URL',
      // },
    };
  }
  return {
    pattern: {
      value: LINK_REGEX,
      message: 'Please enter valid URL',
    },
  };
};
